import * as React from "react";

const Canvas = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 15 14"
    fill="none"
  >
    <path
      d="M5.62728 13.6667C5.26061 13.6667 4.94683 13.5363 4.68595 13.2754C4.42461 13.014 4.29395 12.7 4.29395 12.3334V5.66671C4.29395 5.30004 4.42461 4.98604 4.68595 4.72471C4.94683 4.46382 5.26061 4.33337 5.62728 4.33337H10.9606L14.9606 8.33337V12.3334C14.9606 12.7 14.8302 13.014 14.5693 13.2754C14.3079 13.5363 13.9939 13.6667 13.6273 13.6667H5.62728ZM10.2939 9.00004V5.66671H5.62728V12.3334H13.6273V9.00004H10.2939Z"
      fill="#F0F0F0"
    />
    <path
      d="M4.29395 0.333374H5.62728V3.00004H4.29395V0.333374Z"
      fill="#F0F0F0"
    />
    <path
      d="M0.293945 5.66671V4.33337H2.96061V5.66671H0.293945Z"
      fill="#F0F0F0"
    />
  </svg>
);

export default Canvas;
